<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`业务委托详情【${detailData.reportCodeStart || ''}】`"
    width="1100px"
    height="95vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <div v-loading="detailLoading">
      <EntrustTable :detailData="detailData" />
    </div>

    <div slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </drag-dialog>
</template>

<script>
import EntrustTable from '@/components/BusinessComponents/EntrustTable';

import { getEntrustmentSet } from '@/api/entrust';

export default {
  components: { EntrustTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      activeCollapse: [],
      detailLoading: false,
      detailData: {}
    };
  },
  computed: {
    isCollapse({ activeCollapse }) {
      return activeCollapse.length == 0;
    }
  },
  watch: {
    visible(val) {
      if (val && this.activeId) this.getDetailData();
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getEntrustmentSet({ id: this.activeId });
        data.sampleInfoList.forEach(item => {
          if (item.imgs) {
            if (this.isJSONObjectOrArray(item.imgs)) {
              const allFiles = JSON.parse(item.imgs);
              item.imgs = allFiles.imgs;

              if (allFiles.imgs) {
                item.imgList = allFiles.imgs.split(',').map(item => {
                  return this.$imgUrl + item;
                });
              }
              item.files = allFiles?.files || [];
            } else {
              item.imgs = item.imgs;
              item.imgList = item.imgs.split(',').map(item => {
                return this.$imgUrl + item;
              });
              item.files = [];
            }
          } else {
            item.imgs = '';
            item.imgList = [];
            item.files = [];
          }
        });
        this.detailData = data ?? {};

        if (data.entrustmentUserList) {
          this.detailData.entrustmentUsers = data.entrustmentUserList.map(item => item.userName).join(',');
        } else {
          this.detailData.entrustmentUsers = '';
        }
      } finally {
        this.detailLoading = false;
      }
    },
    isJSONObjectOrArray(str) {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.record-code {
  font-size: 14px;
  color: #101010;
  margin-bottom: 14px;
}

::v-deep .el-step__title {
  line-height: 1.5em;
  padding-top: 4px;
}

.collapse-title {
  width: 100%;
}

.other-info {
  > div {
    display: flex;
    align-items: flex-start;
    margin: 5px 0;
    font-size: 14px;
    line-height: 1.5em;
    color: #101010;
  }
  .sign-image {
    width: 140px;
    height: auto;
  }
}

::v-deep .el-table__header {
  .el-table__cell {
    background: #f2f2f2;
    color: #606266;
  }
}
</style>
